import { eventBus, LOGIN_EVENTS } from "./eventBus";
import { setStorage, getStorage } from "./storage";
import type { UserStoreInfo } from "../types/store";

/**
 * 全局登录状态管理
 */
export class GlobalAuth {
  /**
   * 设置登录状态并通知所有应用
   * @param token 用户token
   * @param userInfo 用户信息
   */
  static setLoginState(token: string, userInfo?: UserStoreInfo) {
    // 保存到 localStorage
    const tokenStr = getStorage("docoiToken");
    const tokenObj = tokenStr ? JSON.parse(tokenStr) : {};
    tokenObj.token = token;
    setStorage("docoiToken", JSON.stringify(tokenObj));

    // 发布登录成功事件
    eventBus.emit(LOGIN_EVENTS.LOGIN_SUCCESS, {
      token,
      userInfo
    });
  }

  /**
   * 全局登出并通知所有应用
   */
  static logout() {
    // 清除 localStorage
    setStorage("docoiToken", "");

    // 发布登出事件
    eventBus.emit(LOGIN_EVENTS.LOGOUT);
  }

  /**
   * 检查是否已登录
   */
  static isLogin(): boolean {
    const tokenStr = getStorage("docoiToken");
    const tokenObj = tokenStr ? JSON.parse(tokenStr) : {};
    return !!tokenObj?.token;
  }

  /**
   * 获取当前token
   */
  static getToken(): string {
    const tokenStr = getStorage("docoiToken");
    const tokenObj = tokenStr ? JSON.parse(tokenStr) : {};
    return tokenObj?.token || "";
  }
}

// 导出便捷方法
export const globalLogin = GlobalAuth.setLoginState;
export const globalLogout = GlobalAuth.logout;
export const isGlobalLogin = GlobalAuth.isLogin;
export const getGlobalToken = GlobalAuth.getToken;
